<template>
  <div class="row m-0">
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex market_news">
          <h1 class="marketplace_header">{{ $t('headlinesTitle') }}</h1>
        </div>
      </div>
     <div class="headline-content" v-if="regulatoryHeadlines.length">
      <div id="myCarousel" class="carousel text-center carousel-style" data-ride="carousel" data-interval="3000">
        <ol v-if="regulatoryHeadlines.length > 1" class="carousel-indicators d-flex pl-10" >
          <template v-for="(alert,index) in regulatoryHeadlines">
            <li v-if="index == 0" data-target="#myCarousel" :data-slide-to="index" :key="alert.id" class="active"></li>
            <li v-else data-target="#myCarousel" :key="index" :data-slide-to="index"></li>
          </template>
        </ol>
        <div class="carousel-inner item-hover" role="listbox">
          <div class="item text-left" v-for="(headline, index) in regulatoryHeadlines" :key="index"
            :class="{ 'active': index == 0 }">
            <div class="d-flex headlines">
              <div >
                <img class="headline_image" :src="`data:image/png;base64, ${headline.byte64_image}`" />
              </div>
              <div class="headline_body">
                <a v-if="headline.redirection_url" class="m-0 headline_title cursor-pointer" :href="headline.redirection_url" target="_blank">{{ headline.title }}</a>
                <span v-else class="m-0 headline_title">{{ headline.title }}</span>
                <div class="m-0 headline_description">{{ headline.description }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
     </div>
     <div v-else class="no-headlines">
       <span class="">{{ $t('headlinesEmptyStateMessage') }}</span>
     </div>
     <div  v-if="roleId===roleInfo['Super Admin']" class="pt-28">
       <button type="button" class="btn view_all_button" @click="viewAll">
           <span class="seeMore pr-8">{{ $t('viewAll') }}</span>
            <img src="/static/images/icons/Back.svg" class="pb-3" />
          </button>
     </div>

  </div>
</template>

<script>
import $ from 'jquery';
import * as moment from 'moment';
import {
  deleteHeadline,
  deleteFeaureHeadline,
} from '../../apis/dashboard';
import {
  getHeadlines,

} from '../../apis/headlines';

export default {
  props: {
    userId: Number,
    roleInfo: Object,
  },
  components: {
  },
  data() {
    return {
      deleteWarningInfo: {
        loaderStatus: false,
        isSelectedList: false,
        title: '',
      },
      selectedHeadLines: [],
      headlineIndex: 0,
      regulatoryHeadlines: [],
      infoActive: false,
      roleId: null,
      propHeadline: '',
      editObj: {},
      operations: {},
      headlines: [],
      operationForAdd: {},
      loaderStatus: false,
      new_headlines: [],

    };
  },
  methods: {
    viewAll() {
      this.$router.push('/layout/headlines');
    },
    async getHeadlines() {
      // this.loaderStatus = true;
      //   const userData = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : await getUserData();
      const response = await getHeadlines();
      if (response.data.length) {
        this.new_headlines = response.data;
      }
    },
    setSelectedHeadLines(healines) {
      this.selectedHeadLines = [...healines];
    },
    goToHeadlines(action) {
      // this.$router.push('/layout/headlines');
      const headlineData = action === 'edit' ? this.regulatoryHeadlines[this.headlineIndex + 1] : this.regulatoryHeadlines[this.headlineIndex + 1].id;
      this.$router.push({
        name: 'Headlines',
        params: { type: action, headline: headlineData },
      });
    },
    getRole() {
      const data = JSON.parse(localStorage.getItem('profileData'));
      return data.role_name === 'Super Admin';
    },

    async openModalDeleteForList(title) {
      this.deleteWarningInfo = {
        ...this.deleteWarningInfo,
        title: `${title}(s)`,
        isSelectedList: true,
      };
      $('#modal_delete').modal({
        backdrop: 'static',
        keyboard: false,
      });
    },

    checkHeadLinesResponse(response) {
      if (response.status_code === 200) {
        this.clearNotifications();
        this.$notify({
          type: 'success',
          title: this.$i18n.locale === 'Portuguese' ? 'Sucesso' : 'Success',
          text: 'Regulatory Headline deleted successfully',
          group: 'custom-notification',
        });
        this.deleteWarningInfo = {
          ...this.deleteWarningInfo,
          loaderStatus: false,
        };
        $('#modal_delete').modal('hide');
        this.getRegulatoryHeadlines();
      } else {
        this.deleteWarningInfo = {
          ...this.deleteWarningInfo,
          loaderStatus: false,
        };
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: 'Deletion of record failed',
          group: 'custom-notification',
        });
      }
    },

    clearNotifications() {
      this.$notify({
        clear: true,
        group: 'custom-notification',
      });
    },
    async dashboardPublishDelete() {
      this.deleteWarningInfo = {
        ...this.deleteWarningInfo,
        loaderStatus: true,
      };
      const headLinesList = this.deleteWarningInfo.isSelectedList ? [...this.selectedHeadLines] : [this.propHeadline.id];
      const body = { id: headLinesList };
      let response;
      if (this.operations.type === 'Featured Content' && this.deleteWarningInfo.isSelectedList) {
        response = await deleteFeaureHeadline(body);
      } else {
        response = await deleteHeadline(body);
      }
      this.checkHeadLinesResponse(response);
      if (this.deleteWarningInfo.isSelectedList) {
        this.operations = { ...this.operations };
      }
    },

    getPathFromURL(url) {
      if (this.selfURL(url)) return new URL(url).pathname;
      return '';
    },
    selfURL(url) {
      return url && url.includes(window.location.hostname);
    },
    async getRegulatoryHeadlines() {
      const response = await getHeadlines();
      if (response.status_code === 200) {
        // this.$nextTick(() => {
        this.regulatoryHeadlines = response.data;
        $('#myCarousel').carousel(0);
        // });
      }
    },
    handleOpenEditPopup(record) {
      this.editObj = {};
      // this.editObj = record;
      this.operationForAdd = {
        type: record.type,
        action_type: 'Edit',
      };
      this.$set(this.editObj, 'newProp', record);
      $('#addPopup').modal({
        backdrop: 'static',
        keyboard: false,
      });
      // $('#listPopup').modal('hide');
    },
    /**
         * openAddPopup()
         * Open the modal popup
         */
    openAddPopup(type = 'Main Headline') {
      this.editObj = {};
      this.operationForAdd = {
        type,
        action_type: 'Add',
      };
      $('#addPopup').modal({
        backdrop: 'static',
        keyboard: false,
      });
    },

    reloadList() {
      this.operations = {
        type: this.editObj.newProp.type,
        action_type: 'Edit',
      };
    },

    openEditPopup(type) {
      this.operations = {
        action_type: 'Edit',
        type,
      };
      $('#listPopup').modal({
        backdrop: 'static',
        keyboard: false,
      });
    },

    handleCloseListPopup() {
      $('#listPopup').modal('hide');
    },
    /**
         * openDeletePopup()
         * Open the modal popup
         */
    openDeletePopup() {
      this.propHeadline = this.regulatoryHeadlines[this.headlineIndex];
      this.deleteWarningInfo = {
        ...this.deleteWarningInfo,
        title: 'headline',
        isSelectedList: false,
      };
      $('#modal_delete').modal({
        backdrop: 'static',
        keyboard: false,
      });
    },
    getImageUrl(filePath, tokenRequired) {
      if (filePath) {
        if (tokenRequired) {
          return `${process.env.VUE_APP_PYTHON_AZURE_BLOB_URL}${filePath}${this.sasToken}`;
        }
        return `${process.env.VUE_APP_PYTHON_AZURE_BLOB_URL}${filePath}`;
      }
      return null;
    },
  },
  computed: {
    /**
         * neHeadlineIndex()
         * Return headline index for new headline
         */
    neHeadlineIndex() {
      let index = 0;
      this.regulatoryHeadlines.forEach((value) => {
        index = index < value.headlines_index ? value.headlines_index : index;
      });
      index += 1;
      return index;
    },
  },
  async created() {
    try {
      this.roleId = JSON.parse(localStorage.getItem('userData')).role_id;
      this.loaderStatus = true;
      await this.getRegulatoryHeadlines();
      this.loaderStatus = false;
    } catch (err) {
      this.loaderStatus = false;
    }
    $('#myCarousel').carousel();
    $('#myCarousel').bind('slid.bs.carousel', () => {
      this.headlineIndex = $('.item.active').index() - 1;
    });
  },
  filters: {
    UTCDate(date, format) {
      return date ? moment.utc(date).format(format) : '';
    },
  },
};
</script>

<style scoped>
.carousel {
  position: inherit;
}
/* .market_news{
  margin-bottom: 6px;
} */
.pr-8 {
  padding-right: 8px;
}
.pt-28 {
  padding-top:28px
}
.view_all_button,
.view_all_button:hover {
  background-color: #01518A;
  height: 34px;
  width: 123px;
  color: #FFFFFF;
  font-size: 16px;
  font-weight: 600;
  border-radius: 3px;
  line-height: 22px;
  float: right;
  cursor: pointer;
  padding: 6px 20px 6px 16px;
}
.no-headlines{
  text-align:center;
  padding-top:30px;
  height: 214px;
}
.marketplace_line {
  border-top: 0.5px solid #C4C4C4;
  margin-left: 10px;
}
/* .market_news_main {
  margin-top: 33px;
} */
.marketplace_image {
  width: 22px;
  margin-left: 10px;

}
.marketplace_header {
  padding-left: 10px;
  font-size: 24px;
  color: #3E3E3E;
  font-weight: 300;
  line-height: 33px;
  margin: 0px;
}
.headline_buttons-section button{
  border: none;
  background-color: transparent;
  padding-top: 0px;
  padding-bottom: 0px;
  padding-right: 0px;
}
.headline_buttons {
  font-size: 18px;
  color: #01518a;
  float: right;
  cursor: pointer;
  font-weight: 700;
  line-height: 25px;
  /* padding-right: 10px; */
}
.pl-8 {
  padding-left: 8px
}
.pl-32 {
  padding-left: 32px;
}
.carousel>>>.carousel-indicators .active {
  /* background: radial-gradient(#00518A 0%, #00518A 46%, transparent 51%, transparent); */
  /* background: #00518A; */
  /* border: 2px solid #00518A; */
  width: 8px;
  height: 8px;
}

.headline_body {
  padding-left: 24px
}

.headline_title {
  font-weight: 400;
  font-size: 20px;
  line-height: 27px;
  color: #01518A;
}
.headline_image {
  width:298px;
  height: 182px;
}

.w-24 {
  width: 24px;
}
.h-24 {
  height: 24px;
}

.headline_description {
  font-weight: 400;
  font-size: 16px;
  line-height: 26px;
  text-align: justify;
  color: #000000;
  margin-top: 16px;
}

.header {
  background: #00518a;
  /* Emergo other blue */
  border: 1px solid #00518a;
  box-sizing: border-box;
  border-radius: 10px 10px 0px 0px;
  min-height: 42px;
}

.title {
  font-family: 'Open Sans';
  font-weight: 400;
  color: #fff;
  padding-left: 15px;
  font-size: 22px !important;
  line-height: 0px !important;
}

.headline-content {
  /* padding: 24px 49px 8px 20px; */
  padding: 32px 18px 0px 10px;
  /* padding: 8px 20px; */
}

.carousel-indicators .active {
  background: #001524;
  pointer-events: none;
}

.carousel-indicators li {
  background-color: #CCCCCC;;
  /* border: 2px solid #4D4D4D; */
  /* margin: 10px; */
  margin-right: 10px;
  width: 8px;
  height: 8px;
  margin-top: 0px;

}

.carousel-indicators {
  /* bottom: -50px; */
  left: unset;
  /* width: 100%; */
  margin-left: unset;
  z-index: 1;
  margin-bottom: -5px;
  margin-left:-11px
}

/* .headlines {
  margin-top: 15px
} */

.admin-features {
  font-size: 16px;
  line-height: 19px;
  text-align: right;
  color: #0b3c61;
  padding: 0px;
}

.admin-features .delete {
  color: #B00505;
}

.reg-headline-add {
  margin-right: 5px;
}

.cursor-pointer {
  cursor: pointer;
}

.limit_popover_txt {
  text-align: left;
  word-break: break-word;
}

.info-img {
  height: 18px;
  width: 18px;
  margin-left: 6px;
}

.margin-icon {
  margin: 0 9px 5px 25px;
}

.text-left {
  text-align: left;
}

.mr-0 {
  margin-right: 0px;
}

.mb-10 {
  margin-bottom: 10px;
}

.date-css {
  font-size: 14px;
}

.date-css {
  font-weight: 500;
  font-size: 16px;
  color: #174c76;
  padding-right: 0px;
  text-align: left;
  /* margin-right: */
}

.content-decoration {
  position: relative;
  padding: 0;
  border-top: 0.5px solid #174c76;
}

.mt-10 {
  margin-top: 10px;
}

.headline-circle {
  position: absolute;
  border-radius: 50%;
  width: 5px;
  height: 5px;
  background: #174c76;
  padding: 0;
  right: 0;
  top: -3px;
}

.heading {
  font-weight: 500;
  font-size: 18px;
  line-height: 20px;
}

.heading.url-hover a:hover {
  text-decoration: underline !important;
  cursor: pointer;
}

.heading a {
  cursor: text;
}

.pb-10 {
  padding-bottom: 10px;
}

.headlines-img {
  width: 40%;
  max-height: 500px !important;
}

.mb-16 {
  margin-bottom: 16px;
}

.headline-details {
  font-weight: 300;
  font-size: 14px;
  line-height: 12px;
  /* Text */
  color: rgba(0, 0, 0, 0.7);
  position: inherit;
}

.cursor-pointer-disable {
  cursor: not-allowed;
}

.seeMore {
  color: #FFFFFF;
  /* font-size: 18px;
  color: #01518a; */
  /* float: right;
  cursor: pointer;
  font-weight: 700;
  line-height: 25px;
  padding-right: 10px;
  margin-top: 20px; */
}

@media only screen and (max-width: 767px) {
  .carousel-style {
    margin-bottom: 30px !important;
  }

  .carousel-inner {
    min-height: auto !important;
  }

  .admin-features {
    font-size: 12px;
  }

  .info-img {
    margin-right: 10px;
  }

  .margin-icon {
    margin: 0px;
  }

  .headlines-img {
    min-height: 180px !important;
  }
}

@media (min-width: 992px) and (max-width: 1200px) {
  /* .carousel-inner {
    min-height: 455px !important;
  } */
}

@media only screen and (max-width: 600px) {
  .admin-features-label {
    display: none;
    left: 85%;
  }
}

@media only screen and (max-width: 400px) {
  .date-css {
    font-size: 14px;
  }
}

@media (min-width: 1201px) and (max-width: 1400px) {
  .date-css {
    font-size: 14px !important;
  }
}

@media (min-width: 1025px) and (max-width: 1280px) {
  .content-decoration {
    border-top: 1px solid #174c76;
  }
}
</style>
